import { forwardRef, type Ref, type SVGProps } from "react";
const IconTownhouseFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M8.12 2.742a2 2 0 0 1 2.76 0L16 7.619l5.12-4.877a2 2 0 0 1 2.76 0l5.5 5.238A2 2 0 0 1 30 9.428v18.381a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.428a2 2 0 0 1 .62-1.448zm-.101 9.442c0-.207.168-.375.375-.375h2.25c.207 0 .375.168.375.375v2.25a.375.375 0 0 1-.375.375h-2.25a.375.375 0 0 1-.375-.375zm0 7.625a1 1 0 0 0-1 1v7h5v-7a1 1 0 0 0-1-1zm12 1a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v7h-5zm1.375-9a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTownhouseFilledSVG);
ForwardRef.displayName = "IconTownhouseFilled";
export { ForwardRef as IconTownhouseFilled };
